/**
 * Returns the public base path for asset URLs so one build works on:
 * - localhost (npm start)
 * - jordanbyrd.com (root)
 * - GitHub Pages (https://golbi-llc.github.io/jordanbyrd)
 */
export function getPublicUrl() {
  if (typeof window === 'undefined') return '';
  if (window.location.pathname.startsWith('/jordanbyrd')) return '/jordanbyrd';
  return '';
}
